<template>
  <div class="animated fadeIn">
    <b-card header="Request Deposit">
      <p v-if="partner && partner.deposit_saldo < 0" class="text-right">Debt on deposit: <span class="text-danger">{{ Math.abs(partner.deposit_saldo) | toRupiah }}</span></p>
      <b-row>
        <b-col md="6" class="mb-3">
          <label for="amount">Amount</label>
          <b-form-input id="amount" v-model="input.amount" name="amount" type="number" min="1" />
        </b-col>
        <b-col md="6" class="mb-3">
          <label for="account-name">Account Name</label>
          <b-form-input id="account-name" v-model.trim="input.account_name" name="account_name" type="text" />
        </b-col>
      </b-row>
      <b-row>
        <b-col md="6" class="mb-3">
          <label for="account-number">Account Number</label>
          <b-form-input id="account-number" v-model.trim="input.account_number" name="account_number" type="text" />
        </b-col>
        <b-col md="6" class="mb-3">
          <label for="bank-name">Bank Name</label>
          <b-form-input id="bank-name" v-model.trim="input.bank_name" name="bank_name" type="text" />
        </b-col>
      </b-row>
      <b-row>
        <b-col md="6" class="mb-3">
          <label for="destination-account">Destination Account</label>
          <b-form-select id="destination-account" v-model="input.destination_account" :options="destinationAccountOptions" name="destination_account" />
        </b-col>
        <b-col md="6" class="mb-3">
          <label for="bank-name">Transfer Receipt</label>
          <b-form-file v-model="input.receipt_file" placeholder="Choose a file..." drop-placeholder="Drop file here..." />
        </b-col>
      </b-row>
      <b-button :disabled="storeState.isProcessing" variant="primary" class="px-4 mt-2" @click="submitTopUpDeposit">Submit</b-button>
    </b-card>
  </div>
</template>

<script>
import { store } from '@/shared/store'
import { getPartnerInfo, getBankAccounts, uploadImage, requestTopUpDeposit, handleError } from '@/services/metal'
import { toRupiah } from '@/shared/utils'
export default {
  name: 'RequestTopUpDeposit',

  filters: {
    toRupiah: function(val) {
      return toRupiah(val)
    }
  }, // filters

  data() {
    return {
      partner: null,
      input: {
        amount: '',
        account_name: '',
        account_number: '',
        bank_name: '',
        destination_account: 0,
        receipt_file: null,
      },
      destinationAccountOptions: [ { value: 0, text: 'Select account...'} ],
      transferReceipt: '',
      prevReceiptFile: '',
      storeState: store.state
    }
  }, // data

  async created() {
    store.setIsInitLoading(true)

    await getPartnerInfo()
      .then(response => {
        this.partner = response.data.data
      })
      .catch(error => {
        handleError(error)
      })

    getBankAccounts()
      .then(response => {
        response.data.data.forEach( data => {
          let destinationAccountOption = {
            value: data.id,
            text: data.bank_name + ' / ' + data.account_number + ' / ' + data.account_name
          }
          this.destinationAccountOptions.push(destinationAccountOption)
        })
        store.setIsInitLoading(false)
      })
      .catch( error => {
        handleError(error)
      })
      .then( () => {
        store.clearProcessing()
      })
  }, // created

  methods: {
    submitTopUpDeposit() {
      store.setIsChildLoading(true)
      store.setIsProcessing(true)

      if (this.prevReceiptFile != this.input.receipt_file) {
        // upload new image
        let formData = new FormData()
        formData.append('image_file', this.input.receipt_file)

        uploadImage(formData)
          .then(response => {
            this.prevReceiptFile = this.input.receipt_file
            this.transferReceipt = response.data.data.uploaded_image_url
            this.handleRequestTopUpDeposit()
          })
          .catch( error => {
            handleError(error)
          })
          .then( () => {
            store.clearProcessing()
          })
      } else {
        // use previous uploaded image
        this.handleRequestTopUpDeposit()
      }
    },

    handleRequestTopUpDeposit() {
      let reqData = {
        amount: this.input.amount,
        requester_account_name: this.input.account_name,
        requester_account_number: this.input.account_number,
        requester_bank_name: this.input.bank_name,
        destination_account_id: this.input.destination_account,
        transfer_receipt: this.transferReceipt,
      }

      requestTopUpDeposit(reqData)
        .then( () => {
          window.scrollTo(0,0)
          store.showAlert('Request top up submitted successfully', 'success')
        })
        .catch( error => {
          handleError(error)
        })
        .then( () => {
          store.clearProcessing()
        })
    },
  }, // methods
}
</script>
